/**
 * Quyền chủ thể dữ liệu (TT 83 C7-b, NĐ 13). Mirror BE `apps/accounts/data_subject_views.py`.
 */
import { apiClient } from "@/api/client";

export type DataRequestKind =
  "access" | "correction" | "deletion" | "withdraw_consent" | "objection";
export type DataRequestStatus = "open" | "done" | "rejected";

export const KIND_LABEL: Record<DataRequestKind, string> = {
  access: "Xem/nhận bản sao dữ liệu",
  correction: "Sửa dữ liệu",
  deletion: "Xoá dữ liệu",
  withdraw_consent: "Rút đồng ý",
  objection: "Phản đối/hạn chế xử lý",
};
export const STATUS_LABEL: Record<DataRequestStatus, string> = {
  open: "Chờ xử lý",
  done: "Đã xử lý",
  rejected: "Từ chối",
};

export interface DataRequest {
  id: number;
  user: number | null;
  user_email: string | null;
  student_id: string | null;
  kind: DataRequestKind;
  detail: string;
  status: DataRequestStatus;
  response: string;
  handled_by_email: string | null;
  handled_at: string | null;
  created_at: string;
}

export interface MyData {
  account: Record<string, unknown>;
  learner_profile: Record<string, unknown> | null;
  enrollments: unknown[];
  attempts: unknown[];
  learning_events: { total: number };
  [k: string]: unknown;
}

export async function getMyData(): Promise<MyData> {
  return (await apiClient.get<MyData>("/auth/me/data/")).data;
}
export async function listMyRequests(): Promise<{ results: DataRequest[] }> {
  return (await apiClient.get("/auth/me/data-requests/")).data;
}
export async function createMyRequest(kind: DataRequestKind, detail: string): Promise<DataRequest> {
  return (await apiClient.post("/auth/me/data-requests/", { kind, detail })).data;
}
export async function listAdminRequests(): Promise<{ results: DataRequest[] }> {
  return (await apiClient.get("/admin/data-requests/")).data;
}
export async function updateAdminRequest(
  id: number,
  body: { status: DataRequestStatus; response: string },
) {
  return (await apiClient.patch<DataRequest>(`/admin/data-requests/${id}/`, body)).data;
}
export async function anonymizeRequestUser(id: number): Promise<DataRequest> {
  return (await apiClient.post(`/admin/data-requests/${id}/anonymize/`)).data;
}
export async function getPiiAccess(userId: number): Promise<{
  results: { created_at: string; actor_email: string | null; purpose: string; fields: string[] }[];
}> {
  return (await apiClient.get(`/admin/users/${userId}/pii-access/`)).data;
}
